<!-- old staff -->
<!-- <nz-form-control *ngIf="recordProperty !== undefined">
  <nz-input-number [nzFormatter]="formatterPrice" nzMin="0" [name]="sectionTagName+'.' +field.FieldName"
      [(ngModel)]="recordProperty.ValueAsObject" [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="valueChanged()"
      [nzDisabled]="recordProperty.ReadOnly">
  </nz-input-number>{{this.currency}}
</nz-form-control> -->

<nz-form-control>
  <nz-input-group nzCompact
    [nzAddOnAfter]="currencyField !== undefined && !addCurrencyBefore ? addOnAfterTemplate : null"
    [nzAddOnBefore]="currencyField !== undefined && addCurrencyBefore ? addOnAfterTemplate : null">
    <nz-input-number
    [class]="parentClass"
    [nzFormatter]="formatterPrice" nzMin="0" [name]="sectionTagName + '.' + field.FieldName"
      [(ngModel)]="recordProperty.ValueAsObject" [ngModelOptions]="{ updateOn: 'blur' }"
      (ngModelChange)="valueChanged()" [nzDisabled]="recordProperty.ReadOnly" [nzParser]="numberParser">
    </nz-input-number>
  </nz-input-group>
</nz-form-control>

<ng-template #addOnAfterTemplate>
  <app-input-select *ngIf="currencyField !== undefined" [recordModel]="recordModel" [field]="currencyField"
    [section]="section" [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
    [actionType]="actionType" [displayPlaceHolder]="false" [width]="75"
    class="currencySelect">
  </app-input-select>
</ng-template>
